import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Theme } from '..';
import { THeader, Row, TableHeaderCell, HeaderLabel } from './elements';
/** Lookup object for icon name from sorting direction. */

var SORT_ORDER_ICON_NAME = {
  none: 'carets-vertical',
  asc: 'caret-up',
  desc: 'caret-down'
};

var TableHeader = function TableHeader(_ref) {
  var colsDef = _ref.colsDef,
      onSortChange = _ref.onSortChange,
      isScrollable = _ref.isScrollable,
      rowHeaderRef = _ref.rowHeaderRef,
      sort = _ref.sort;

  var handleSortChange = function handleSortChange(column) {
    var defaultSortOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
    var nextSort = defaultSortOrder === 'asc' ? 'desc' : 'asc';

    if (column) {
      if (sort && sort.column === column && sort.order === defaultSortOrder) {
        onSortChange({
          column: column,
          order: nextSort
        });
      } else if (sort && sort.column === column && sort.order === nextSort) {
        onSortChange(null);
      } else {
        onSortChange({
          column: column,
          order: defaultSortOrder
        });
      }
    }
  };

  return /*#__PURE__*/React.createElement(THeader, null, /*#__PURE__*/React.createElement(Row, null, colsDef.map(function (_ref2) {
    var name = _ref2.name,
        title = _ref2.title,
        isSortable = _ref2.isSortable,
        defaultSortOrder = _ref2.defaultSortOrder,
        align = _ref2.align,
        isRowHeader = _ref2.isRowHeader;
    return /*#__PURE__*/React.createElement(TableHeaderCell, {
      ref: isRowHeader ? rowHeaderRef : null,
      isScrollable: isScrollable,
      isSortable: isSortable,
      isRowHeader: isRowHeader,
      scope: "col",
      key: "".concat(name),
      align: align,
      onClick: function onClick() {
        return isSortable && name ? handleSortChange(name, defaultSortOrder) : undefined;
      }
    }, /*#__PURE__*/React.createElement(HeaderLabel, null, title), isSortable && /*#__PURE__*/React.createElement(Icon, {
      name: SORT_ORDER_ICON_NAME[sort && sort.column === name && sort.order || 'none'],
      color: Theme.palette.mediumGrey,
      width: "10px",
      height: "10px"
    }));
  })));
};

var arrayOf = PropTypes.arrayOf,
    bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    number = PropTypes.number,
    object = PropTypes.object,
    oneOf = PropTypes.oneOf,
    oneOfType = PropTypes.oneOfType,
    shape = PropTypes.shape,
    string = PropTypes.string;
/** Prop types. */

TableHeader.propTypes = {
  colsDef: arrayOf(shape({
    align: oneOf(['left', 'center', 'right']),
    isRowHeader: bool,
    filteredBy: func,
    format: func,
    isSortable: bool,
    title: node.isRequired,
    total: func,
    value: func.isRequired,
    width: oneOfType([string, number])
  })).isRequired,
  onSortChange: func.isRequired,
  isScrollable: bool,
  rowHeaderRef: object.isRequired,
  sort: shape({
    column: string,
    order: oneOf(['asc', 'desc'])
  })
};
/** Default props. */

TableHeader.defaultProps = {
  isScrollable: false,
  sort: null
};
export default React.memo(TableHeader);